module.exports = __webpack_public_path__ + "img/ico-calender.bc3d75dd.svg";